import type {
  LoginType,
  Web3LoginSupportedType,
} from "@features/auth/compat/sdk-types";
import { Bind, OpenApiClient, Owner, ProfileDTO } from "@features/api/openApi";
/*
 * @Author: jikang.wu@kikitrade.com jikang.wu@kikitrade.com
 * @Date: 2025-03-07 15:47:41
 * @LastEditors: jikang.wu@kikitrade.com jikang.wu@kikitrade.com
 * @LastEditTime: 2025-03-07 16:41:45
 * @FilePath: /ai-chat_token_seek/apps/token-seek/src/store/types.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

export interface LoginState {
  isLoading?: boolean;
  /** 用户已点击 Web 三方登录、等待 SDK/OAuth 反馈（与 isLoading 分离，避免点击到授权前无 loading） */
  isSocialLoginIntent?: boolean;
  isLoggedIn?: boolean;
  isFetching?: boolean;
  loginType?: LoginType;
  subLoginType?: Web3LoginSupportedType;
  eoaAddress?: string | null;
  auth?: LoginAuthInfo;
  loginComplete: (params: LoginCompleteParams) => void;
  updateAuthInfo: (auth: LoginAuthInfo) => void;
}

export type LoginCompleteParams = {
  loginType: LoginType;
  eoaAddress: string | null;
  auth: LoginAuthInfo;
  subLoginType?: Web3LoginSupportedType;
};

export type LoginAuthInfo = {
  idToken?: string;
  accessToken: string;
  refreshToken?: string;
};

export type EdgenUserInfo = Owner & {
  /** Ed 称呼用户的昵称（V2.8 POST /owners/{id}/setting） */
  nick_name?: string;
  bindInfo?: Omit<Bind, "owner" | "profile">;
  ospProfile?: ProfileDTO;
  name?: string;
  /** platform/owners 返回的 track_meta（含后端归因广告来源 ad_source） */
  track_meta?: Record<string, unknown> & {
    ad_source?: string;
    adjust_adid?: string;
    advertising_id?: string;
    idfa?: string;
  };
};

export interface UserState {
  ownerInfo?: EdgenUserInfo | null;
  eoaAddress?: string | null;
  clearUser: () => void;
  apiClient?: OpenApiClient<any>;
  fetchUserInfo: (eoaAddress?: string, isLoggedIn?: boolean) => void;
  /**
   * 从缓存恢复用户信息（激进策略）
   * @returns {boolean} 是否成功从缓存恢复
   */
  fetchUserInfoFromCache: () => boolean;
  fingerprint?: string | null;
  accessToken?: string | null;
  turnstileToken?: string | null;
  // 为undefined时表示还没请求过用户的profile信息
  // hasProfile的标示修改为有ownerInfo了
  profileState?:
    "notFetched" | "noProfile" | "hasProfile" | "fetching" | "error";
  locale?: string | null;
  enableNotification: boolean;
}

export interface TokenInfo {
  pool: string;
  ts: number;
  vol_24h: string;
  vol_24h_usdt: string;
  price: string;
  price_usdt: string;
  smart_buy_vol_5m: string;
  smart_buy_vol_5m_usdt: string;
  smart_buy_vol_1h: string;
  smart_buy_vol_1h_usdt: string;
  smart_buy_vol_6h: string;
  smart_buy_vol_6h_usdt: string;
  smart_buy_vol_24h: string;
  smart_buy_vol_24h_usdt: string;
  smart_sell_vol_5m: string;
  smart_sell_vol_5m_usdt: string;

  smart_sell_vol_1h: string;
  smart_sell_vol_1h_usdt: string;
  smart_sell_vol_6h: string;
  smart_sell_vol_6h_usdt: string;
  smart_sell_vol_24h: string;
  smart_sell_vol_24h_usdt: string;
  price_change_5m: string;
  price_change_1h: string;
  price_change_6h: string;
  price_change_24h: string;
  price_change_7d: string;
  vol_change_5m: string;
  vol_change_1h: string;
  vol_change_pre_5m: string;
  vol_change_pre_1h: string;
  txns_5m: string;
  txns_1h: string;
  txns_6h: string;
  txns_24h: string;
}
export interface CoinmarketCapToken {
  pool: string;
  type: string;
  id: string;
  price_usdt: string;
  price_change_1h: string;
  price_change_6h: string;
  price_change_7d: string;
  price_change_24h: string;
  turnover_rate: string;
  vol_24h_usdt: string;
}
export interface TokenState {
  tokenList: TokenInfo[];
  updateToken: (token: TokenInfo[]) => void;
  getTokenByPool: (poolId: string) => TokenInfo | undefined;
  clearTokenList: () => void;
  initTokenList: (tokens: TokenInfo[]) => void;
  coinmarketcapTokenList: CoinmarketCapToken[];
  updateCoinmarketcapToken: (token: CoinmarketCapToken[]) => void;
  getCoinmarketcapTokenByPool: (
    poolId: string,
  ) => CoinmarketCapToken | undefined;

  // 批量更新相关属性 - tokenList
  _pendingTokenUpdates: Map<string, TokenInfo>;
  _lastUpdateTime: number; // 记录上次更新时间
  addTokenUpdate: (tokens: TokenInfo[]) => void;
  _processPendingTokenUpdates: () => void;

  // 批量更新相关属性 - coinmarketcapTokenList
  _pendingCoinmarketcapTokenUpdates: Map<string, CoinmarketCapToken>;
  _lastCoinmarketcapUpdateTime: number; // 记录coinmarketcap上次更新时间
  addCoinmarketcapTokenUpdate: (tokens: CoinmarketCapToken[]) => void;
  _processPendingCoinmarketcapTokenUpdates: () => void;
}

export type ChatMode = "qa" | "agent-performance";

export interface ChatState {
  initChat?: string;
  initCustomParams?: Record<string, any>;
  loading?: boolean;
  showRecommendQuestion?: boolean;
  isOnboarding?: boolean;
  hasChatModal?: boolean;
  stop?: ({
    errorCode,
    stopParams,
  }: {
    errorCode?: number;
    stopParams?: Record<string, any>;
  }) => void;
  streamMessage?: any;
  isDeepsearch?: boolean;
  sessionId?: string;
  isTransform?: boolean;
  tpl?: boolean;
  recoverQuestionParams?: Record<string, any>;
  chatMode?: ChatMode;
}

export interface AppState {
  type: "website" | "extension";
  portfolioChartVisabled?: boolean;
}

export interface ModalState {
  // APP 升级弹窗显示中
  appVersionUpdateModalVisible?: boolean;
  // 应用评分弹窗显示中
  appRatingModalVisible?: boolean;
}

export enum AlphaMarketTabEnum {
  US = "US",
  HK = "HK",
  CRYPTO = "CRYPTO",
  ETF = "ETF",
}

/** Invest H5 一级 Tab：Activity / Opportunity / Portfolio */
export const INVEST_PRIMARY_TAB_PORTFOLIO = "PORTFOLIO" as const;
export const INVEST_PRIMARY_TAB_ACTIVITY = "ACTIVITY" as const;
export const INVEST_PRIMARY_TAB_OPPORTUNITY = "OPPORTUNITY" as const;

export type InvestPrimaryTabId =
  | typeof INVEST_PRIMARY_TAB_ACTIVITY
  | typeof INVEST_PRIMARY_TAB_OPPORTUNITY
  | typeof INVEST_PRIMARY_TAB_PORTFOLIO;

export interface HomeState {
  type: "crypto" | "stock";
  isOpen: boolean;
  /** 上次离开的 Invest 一级 Tab，供底部 Shell Invest 链接恢复 */
  activeTab: InvestPrimaryTabId | undefined;
  /** Invest Moves - Ed Flagged For You 是否已展开 */
  investMovesEdFlaggedExpanded: boolean;
}

export interface StockData {
  // 股票代码
  s: string;
  // 最新价格
  p: string;
  // 时间戳
  t: number;
  // 今日交易量
  tv: number;
}

export interface StockState {
  stockMap: Record<string, StockData>;
  updateStock: (stock: StockData[]) => void;
  clearStockMap: () => void;
  updateTime: number;
}
